export default __webpack_public_path__ + "static/tile-1-bg-8b3f5b5de64a9cc641e6931ea7958220.jpg";